import { FileText, Presentation, Youtube, FileType2 } from 'lucide-react';

import Container from '../../Main/sections/Container';
import Reveal from '../../../components/Reveal';

const FORMATS = [
  {
    icon: FileText,
    color: '#f87171',
    title: 'PDF Documents',
    body: 'Lecture notes, textbook chapters, research papers — any PDF instantly parsed and restructured.',
  },
  {
    icon: Presentation,
    color: '#fb923c',
    title: 'PowerPoint Slides',
    body: 'Drop in .pptx or .ppt lecture slides. We extract headings, bullet points and images automatically.',
  },
  {
    icon: Youtube,
    color: '#5ED8B2',
    title: 'Video Lectures',
    body: 'Paste a YouTube or lecture recording URL. We transcribe, summarise and highlight key moments.',
  },
  {
    icon: FileType2,
    color: '#60a5fa',
    title: 'Plain Text & Docs',
    body: 'Paste raw text, upload Word docs, or type your own notes — AI structures it all for you.',
  },
];

const SupportedFormats = () => {
  return (
    <section className="relative py-20 lg:py-24">
      <Container>
        <Reveal className="text-center">
          <span className="eyebrow">Supported Formats</span>
          <h2 className="font-heading mx-auto mt-5 max-w-3xl text-[2rem] font-bold leading-[1.1] sm:text-[2.6rem] lg:text-[3rem]">
            <span className="head-fade">Works with </span>
            <span className="text-accent-grad">Everything You Have</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-[0.95rem] text-white/55">
            Upload from any source — we handle the heavy lifting no matter what
            format your study material comes in.
          </p>
        </Reveal>

        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {FORMATS.map((f, i) => (
            <Reveal key={f.title} delay={i * 90}>
              <div className="glass glass-hover h-full rounded-2xl p-6">
                <span
                  className="flex h-11 w-11 items-center justify-center rounded-xl"
                  style={{ background: `${f.color}1f`, color: f.color }}
                >
                  <f.icon size={22} />
                </span>
                <h3 className="font-heading mt-5 text-[1.15rem] font-semibold text-white">
                  {f.title}
                </h3>
                <p className="mt-2 text-[0.88rem] leading-relaxed text-white/55">
                  {f.body}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default SupportedFormats;
